import { render, staticRenderFns } from "./FeatureRequestButton.vue?vue&type=template&id=6dc81794&scoped=true"
import script from "./FeatureRequestButton.vue?vue&type=script&lang=js"
export * from "./FeatureRequestButton.vue?vue&type=script&lang=js"
import style0 from "./FeatureRequestButton.vue?vue&type=style&index=0&id=6dc81794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc81794",
  null
  
)

export default component.exports